export default __webpack_public_path__ + "static/media/hiw_2.2d0a142d.svg";